/* eslint-disable */
import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import QueueAnim from 'rc-queue-anim'
import Icon from './Icon'
import SuccessSvg from '../../static/images/success-black.svg'
import FailSvg from '../../static/images/fail-black.svg'
import zIndex from '../../utils/zIndexScale'

const Layer = styled.div`
  position: fixed;
  top: 50px;
  right: 5px;
  z-index: ${zIndex.modal};
  width: 340px;
  min-height: 90px;
  background: ${props => props.theme.bg2 || '#1E2126'};
  box-shadow: ${props => props.theme.boxShadow || '0px 0px 10px 0px rgba(0,0,0,0.5)'};
`

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

const NotifyIcon = styled.div`
  width: 30px;
  margin: 0 20px;
  img {
    width: inherit;
  }
`

const Content = styled.div`
  padding: 15px 0;
  font-size: 16px;
  color: ${props => props.theme.fontColor || '#fff'};
`

const Title = styled.div`
  font-size: 14px;
`

const Msg = styled.div`
  font-size: 12px;
  max-width: 235px;
  word-break: break-all;
`

const Close = styled.div`
  position: absolute;
  top: 5px;
  right: 5px;
  cursor: pointer;
  color: ${props => props.theme.fontColor || '#fff'};
  &:hover {
    color: #f0b90b;
  }
`

class Notifycation extends PureComponent {
  static propTypes = {
    closeText: PropTypes.string,
    title: PropTypes.string,
    children: PropTypes.element,
    close: PropTypes.func,
    closeAlign: PropTypes.string,
  }

  static defaultProps = {
    closeText: 'close',
    title: '',
    children: null,
    closeAlign: 'flex-end',
    close: () => {},
  }

  componentDidMount() {
    const { close } = this.props
    this.timoutHandle = setTimeout(() => {
      close && close()
    }, 5000)
  }

  render() {
    const { title, msg, type, close } = this.props
    return (
      <QueueAnim leaveReverse={true} delay={100} type={['right', 'left']}>
        <Layer key="1">
          <Wrapper>
            <NotifyIcon>
              {<img src={type === 'success' ? SuccessSvg : FailSvg} alt={true} />}
            </NotifyIcon>
            <Content>
              <Title>{title}</Title>
              <Msg>{msg}</Msg>
            </Content>
            <Close onClick={close}>
              <Icon type="close" size="16" />
            </Close>
          </Wrapper>
        </Layer>
      </QueueAnim>
    )
  }

  componentWillUnmount() {
    clearTimeout(this.timoutHandle)
  }
}

export default Notifycation
